"use strict";

Shopify.theme.jsFAQ = {
  init: function init() {
    var $faqHeading = $('.faq-accordion > dt > button');
    $('.faq-accordion > dd').attr('aria-hidden', true);
    $faqHeading.attr('aria-expanded', false);

    // Guard against double initialisation.
    // This page loads both app.js and app-2.js, and each of them runs the
    // section init loop on document ready, so init() can fire more than once.
    // Without this cleanup the click handler gets bound twice and a single
    // click toggles the panel twice, so it opens and then closes immediately
    // (the "bouncing" behaviour). Namespaced events let us safely remove only
    // the FAQ handlers before re-binding them.
    $faqHeading.off('click.faq activate.faq keydown.faq');

    $faqHeading.on('click.faq activate.faq', function () {
      var faqTitle = $(this);
      var faqIcons = $(this).find('.icon');
      var state = $(this).attr('aria-expanded') === 'false' ? true : false;
      $(this).attr('aria-expanded', state);
      $(this).parent().next().slideToggle(function () {
        if (faqIcons.hasClass('icon--active')) {
          faqIcons.toggleClass('icon--active');
        }
      });
      $(this).parent().next().attr('aria-hidden', !state);
      return false;
    });
    $faqHeading.on('keydown.faq', function (event) {
      var keyCode = event.keyCode || event.which;

      if (keyCode === 13) {
        $(this).trigger('activate.faq');
      }
    });
  },
  unload: function unload() {
    $('.faq-accordion > dt > button').off('click.faq activate.faq keydown.faq');
  }
};